import request from '@utils/request'

export function fetchList(params) {
  return request({
    url: '/admin/account',
    method: 'get',
    params,
  })
}

export function fetchBalanceLogList(params) {
  return request({
    url: `/admin/account/${params.account_seq}/balance-log`,
    method: 'get',
    params,
  })
}

export function fetchAccount(account_seq) {
  return request.get(`/admin/account/${account_seq || 0}`)
}

export function createAccount(data) {
  return request.post('/admin/account', data)
}

export function updateAccount({ account_seq, ...data }) {
  return request.put(`/admin/account/${account_seq || 0}`, data)
}

export function setAccountBalance({ account_seq, ...data }) {
  return request.patch(`/admin/account/${account_seq || 0}`, {
    ...data,
    type: 'SET_BALANCE',
  })
}

export function setAccountFraud({ account_seq, ...data }) {
  return request.patch(`/admin/account/${account_seq || 0}`, {
    ...data,
    type: 'SET_FRAUD',
  })
}

export function setAccountOpen({ account_seq, ...data }) {
  return request.patch(`/admin/account/${account_seq || 0}`, {
    ...data,
    type: 'SET_OPEN',
  })
}

export function deleteAccount(account_seq) {
  return request.delete(`/admin/account/${account_seq || 0}`)
}

export function fetchAccountAddress(address_seq) {
  return request.get(`/admin/account/address/${address_seq || 0}`)
}

export function fetchAccountTransferList(params) {
  return request({
    url: '/admin/account/transfer',
    method: 'get',
    params,
  })
}

export function fetchAccountTransfer(transfer_seq) {
  return request.get(`/admin/account/transfer/${transfer_seq || 0}`)
}
